import { useMutation } from 'react-query';
import { deleteRecognitionAsync } from '../../index';
import { getAllRecognitionsByLicenseAsync } from '../../index';
import { getTemporaryImageUrlFromPublicUrl } from 'services/DefaultService';

export const useDeleteRecognitionAsync = () =>
  useMutation(deleteRecognitionAsync);

export const useGetAllRecognitionsByLicenseAsync = () =>
  useMutation(getAllRecognitionsByLicenseAsync);

export const useLoadFirebaseImageMutation = () => {
    return useMutation((publicUrl: string) =>
      getTemporaryImageUrlFromPublicUrl(publicUrl),
    );
  };